import AppSetting from '../../common/constants/appsetting.constant';
import Countries from '../../common/constants/countries.constant';
import StorageType from '../session/storage.enum';
import StorageService from '../session/storage.service';
import axios from 'axios'

const DoctorService = {

  loggedInUserData: {},
  countryList: Countries,

  doctorList: [],

  getLoggedInData() {
    return JSON.parse(StorageService.get(StorageType.session, 'userDetails'));
  },
  
  find(reqObj) {
    let loggedInUserData = this.getLoggedInData();

    let url = '';
    url = AppSetting.doctor.find.replace('{providerId}', loggedInUserData.parentId);
    url = `${url}${this.buildQuery(reqObj)}`;

    return axios.get(url)
      .then(res => { return res.data })
      .catch(err => { console.log(err) })
  },
  findWithServices(reqObj) {
    let loggedInUserData = this.getLoggedInData();

    let url = '';
    url = AppSetting.doctor.findWithServices.replace('{providerId}', loggedInUserData.parentId);
    url = `${url}${this.buildQuery(reqObj)}`;

    return axios.get(url)
      .then(res => { return res.data })
      .catch(err => { console.log(err) })
  },

  getById(doctorId) {
    let loggedInUserData = this.getLoggedInData();
    let url;

    url = AppSetting.doctor.getById
      .replace('{providerId}', loggedInUserData.parentId)
      .replace('{doctorId}', doctorId);

    return axios.get(url)
      .then(res => { return res.data })
      .catch(err => { console.log(err) })

  },
  getAvailableDoctorForDate(locationId, reqObj) {
    let loggedInUserData = this.getLoggedInData();
    let url = '';

    url = AppSetting.doctor.getAvailableDoctorForDate
      .replace('{providerId}', loggedInUserData.parentId)
      .replace('{locationId}', locationId);
    url = `${url}${this.buildQuery(reqObj)}`;
    return axios.get(url)
      .then(res => { return res.data })
      .catch(err => { console.log(err) })
  },
  getNPIRegistry(reqObj) {
    //let loggedInUserData = this.getLoggedInData();
    let url;

    url = AppSetting.doctor.getNPIRegistry + this.buildQuery(reqObj);

    return axios.get(url)
      .then(res => { return res.data })
      .catch(err => { console.log(err) })

  },

  add(reqObj) {
    let loggedInUserData = this.getLoggedInData();
    let url = '';

    url = AppSetting.doctor.add
      .replace('{providerId}', loggedInUserData.parentId);

    return axios.post(url, reqObj)
      .then(res => { return res })
      .catch(err => { return err })
  },

  update(reqObj, doctorId) {
    let loggedInUserData = this.getLoggedInData();

    let url = '';
    url = AppSetting.doctor.edit
      .replace('{providerId}', loggedInUserData.parentId)
      .replace('{doctorId}', doctorId);

    return axios.put(url, reqObj)
      .then((res) => { return res})
      .catch(err => {console.log(err); return err})
  },

  delete(doctorId, doctor) {
    let loggedInUserData = this.getLoggedInData()
    let url = AppSetting.doctor.delete.replace('{doctorId}', doctorId).replace('{providerId}', loggedInUserData.parentId)
    axios.delete(url)
      .then(res => {return res})
      .catch(err => { return err })
  },

  linkDoctor(doctorId) {
    const url = AppSetting.doctor.link
      .replace('{providerId}', loggedInUserData.parentId)
      .replace('{doctorId}', doctorId);
    return axios.post(url, {})
      .then(res => { return res.data })
      .catch(err => { console.log(err) })
  },

  activatePractitioner(providerId) {
    let loggedInUserData = this.getLoggedInData();
    let url;

    url = AppSetting.doctor.activateDeactivatePractitioners
      .replace('{providerId}', loggedInUserData.parentId)
      .replace('{doctorId}', providerId);

    return axios.post(url, {})
      .then(res => { return res })
      .catch(err => {return err})
  },

  deactivatePractitioner(providerId) {
    let loggedInUserData = this.getLoggedInData();
    let url;
    url = AppSetting.doctor.activateDeactivatePractitioners
      .replace('{providerId}', loggedInUserData.parentId)
      .replace('{doctorId}', providerId);

    return axios.delete(url)
      .then(res => { return res })
      .catch(err => { return err })
  },

  buildQuery(data) {
    let queryData = '';
    for (const prop in data) {
      if (data[prop] !== '' && data[prop] !== 'undefined' && data[prop] !== null && data[prop]?.length !== 0) {
        if (queryData === '') {
          queryData = '?' + prop + '=' + data[prop];
        } else {
          queryData += '&' + prop + '=' + data[prop];
        }
      }
    }
    return queryData;
  },

  // providers/{providerId}/patients/lookup
  doctorLookup(reqObj) {
    this.loggedInUserData = this.getLoggedInData();
    let url = '';
    if(reqObj?.practiceId){
      url = AppSetting.doctor.lookup
      .replace('{providerId}', reqObj.practiceId)
    }
    else{
      url = AppSetting.doctor.lookup
      .replace('{providerId}', this.getLoggedInData()['parentId'])
    }
    url = `${url}${this.buildQuery(reqObj)}`
    return axios.get(url)
      .then(
        (res) => {
          let results = res.data;
          results.forEach(item=>{
            item.fullName = item.firstName[0]+' '+item.lastName
          })
          // console.log(results);
          return results
        })
      .catch(err => { console.log(err) })
  },

  doctorLookupByPracticelocation(reqObj) {
    this.loggedInUserData = this.getLoggedInData();
    let url = '';
    url = AppSetting.doctor.practiceLocationDoctor
      .replace('{providerId}', this.getLoggedInData()['parentId']) + this.buildQuery(reqObj);

    return axios.get(url)
      .then(
        (res) => {
          return res.data
        })
      .catch(err => { console.log(err) })
  },

  doctorTypeLookup() {

     let loggedInUserData = this.getLoggedInData();
    let url = '';
    url = AppSetting.doctor.typeLookup
      .replace('{providerId}',  loggedInUserData.parentId);

    return axios.get(url).then(
      tap(_ => axios.log(`deleted id`)),
      catchError(axios.handleError('delete'))
    );
  },

  mapCountryName(countryId) {
    for (let i = 0; i < this.countryList.length; i++) {
      const element = this.countryList[i];
      if (this.countryList[i].countryId === countryId) {
        return this.countryList[i].name;
      }
    }
  },

  checkAvailabilityForDoctor(id,reqObj) {
     let loggedInUserData = this.getLoggedInData();

    let url = AppSetting.doctor.checkAvailabilityForDoctor
      .replace('{providerId}',  loggedInUserData.parentId)
      .replace('{doctorId}',  id)

    url = `${url}${this.buildQuery(reqObj)}`;

    return axios.get(url)
      .then(res => { return res })
      .catch(err => { console.log(err) })
  },
  getLocationAvailablity(reqObj){
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.doctor.getLocationAvailablity
      .replace('{providerId}',  loggedInUserData.parentId)


    url = `${url}${this.buildQuery(reqObj)}`;

    return axios.get(url)
      .then(res => { return res })
      .catch(err => { return err })
  },
  updateAvailability(id, reqObj){
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.doctor.updateAvailability
      .replace('{providerId}',  loggedInUserData.parentId)
      .replace('{id}',  id)

    return axios.put(url, reqObj)
      .then(res => { return res })
      .catch(err => { return err })
  },
  addAvailability(reqObj){
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.doctor.addAvailability
      .replace('{providerId}',  loggedInUserData.parentId)

    return axios.post(url, reqObj)
      .then(res => { return res })
      .catch(err => { return err })
  },
  getProviderLocationDetails(reqObj){
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.doctor.getProviderLocationDetails
      .replace('{providerId}',  loggedInUserData.parentId)

    url = `${url}${this.buildQuery(reqObj)}`;

    return axios.get(url)
      .then(res => { return res })
      .catch(err => { return err })
  }

}

export default DoctorService